<template>
<div >
    <p class="title">提疑与获取澄清修改文件（招标）</p>
    <div>
        <p>1、点击“提疑与获取澄清修改文件（招标）”，打开提疑与澄清页面。</p>
        <img src="../assets/help/1.6.4-1.jpg" alt="">
        <p>2、点击“新增”，打开新增异议与投诉页面。</p>
        <img src="../assets/help/1.6.4-2.jpg" alt="">
        <p>3、当招标人上传澄清与修改文件后，投标人可以对其进行回执发回。</p>
        <img src="../assets/help/1.6.4-3.jpg" alt="">
    </div>
</div>
</template>
<script>
export default {
    name:'center',
    data(){
        return{
            
        }

    }
}
</script>
<style>

</style>